import React from 'react'
import './styles.css'

interface TextFieldProps {
    value: string,
    placeholder: string,
    onChange(e: string): any
    id?: string
}

export default function TextField(props: TextFieldProps): JSX.Element {
    const handleChange = (e: any) => {
        props.onChange(e)
    }
    return (
        <div className="textfield-wrapper">
            <input
                className='textfield'
                id={props.id || 'textfield'}
                placeholder={props.placeholder}
                type='text'
                value={props.value}
                onChange={handleChange}
            />
        </div>
    )
}